import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getDocumentsId } from "../../redux/actions/actionDocument";
import { format } from "date-fns";
import DetailPresupuestoPDF from "./detailPrespuestoPdf";

export default function DetailPresupuesto() {

    const dispatch = useDispatch();    
    const documentId = useSelector(state => state.documents.documentsDetail)
    const [verPDF, setVerPDF] = useState(false);
    const [pdfBruto, setPdfBruto] = useState(false)
    const { id } = useParams();


    useEffect(() => {
        //dispatch(getIdPresupuesto(id)) 
        dispatch(getDocumentsId(id))       
    }, [dispatch, id]);

    console.log(id);
    //console.log(presupuestoId);
    console.log(documentId);
    


    const opendPDF = () => {
        setVerPDF(true);
        setPdfBruto(false)
      };

    const brutoPDF = () => {
        setVerPDF(true);
        setPdfBruto(true)
    }

    
    return (
        <div className="container bg-gray-900">
            <div className="m-8 text-orange-500 text-[10pt] font-bold">
                <div className="text-xl pb-8 underline">
                    Presupuesto - Detalle
                </div>
                <div className="w-32 text-center bg-slate-700 hover:text-white border-2 border-black">
                    <Link to={`/presupuestos/modificar/${id}`}>
                        <p>Modificar</p>                        
                    </Link>
                    </div>

                <div className="flex w-4/4 mt-6 border-b-2 border-slate-500 pb-2">
                    <p className="w-1/4">Documento N°: {documentId.numberDocument}</p>
                    <p className="w-1/4">Fecha: {documentId.createdAt ? format(new Date(documentId.createdAt), "dd/MM/yyyy") : null}</p>
                    <p className="w-1/3">Facturas Asociadas: {documentId.facturasAsociadas}</p>
                    {/* <p className="w-1/4">Estado: {documentId.approved === true ? "APROBADO" : " - "}</p>
                    {documentId.approved === false ? <button className="w-1/4" onClick={handleAprobar} value={"aprobado"}>Aprobar</button> : <p></p>} */}
                </div>
                <div>
                    {documentId.client_id === undefined ? (
                        <div className="py-2 pb-2 border-b-2 border-slate-500">
                        <div className="flex">
                            <p className="w-1/4">Cliente N°:</p>
                            <p className="w-1/4">Compañia:</p>
                            <p className="w-1/4">Nombre:</p>
                            <p className="w-1/4">Apellido:</p>
                        </div>
                        <div className="flex">
                            <p className="w-1/4">Dirección:</p>
                            <p className="w-1/4">Ciudad:</p>
                            <p className="w-1/4">Teléfonos:</p>
                            <p className="w-1/4">E-mail:</p>
                        </div>
                        </div>
                    ) : (
                        <div className="py-2 pb-2 border-b-2 border-slate-500">
                        <div className="flex">
                            <p className="w-1/4">Cliente N°: {documentId.client_id.idClient}</p>
                            <p className="w-1/4">Compañia: {documentId.client_id.nameCompany}</p>
                            <p className="w-1/4">Nombre: {documentId.client_id.name}</p>
                            <p className="w-1/4">Apellido: {documentId.client_id.lastName}</p>
                        </div>
                        <div className="flex">
                            <p className="w-1/4">Dirección: {documentId.client_id.address}</p>
                            <p className="w-1/4">Ciudad: {documentId.client_id.city}</p>
                            <p className="w-1/4">Teléfonos: {documentId.client_id.telephoneNumber}</p>
                            <p className="w-1/4">E-mail: {documentId.client_id.email}</p>
                        </div>
                        </div>
                    )}
                </div>
                <div className="flex w-3/3 border-b-2 border-slate-500 py-2">
                    <p className="w-1/3">Dirección de Evento: {documentId.addressEvent}</p>
                    <p className="w-1/3">Fecha de Envío: {documentId.dateSend ? format(new Date(documentId.dateSend), "dd/MM/yyyy") : null}</p>
                    <p className="w-1/3">Fecha de Recepcion: {documentId.dateReception ? format(new Date(documentId.dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
                </div>
                <div className="flex border-b-2 border-slate-500">
                    <p className="w-1/3">Nombre</p>
                    <p className="w-2/4">Descripción</p>
                    <p className="w-20 text-center">Presupu -estado</p>
                    <p className="w-20 text-center">Cantidad</p>
                    <p className="w-20 text-center">Pre Unit</p>
                    <p className="w-20 text-center">Importe</p>
                </div>
                <div>
                    {documentId.quantityItems && documentId.quantityItems.map(e=> {
                        return (
                            <div className="flex border-b-2 border-slate-500 text-[9pt]" key={e.item}>
                            <p className="w-1/3">{e.name}</p>
                            <p className="w-2/4">{e.descrip}</p>
                            <p className="w-20 text-center">{e.presupuesto}</p>
                            <p className="w-20 text-center">{e.quantity}</p>
                            <p className="w-20 text-center">{e.price}</p>
                            <p className="w-20 text-center">{e.totalPrice}</p>
                            </div>
                        )
                    })
                    }
                </div>
                    <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
                        <div className="w-[1000px]">Subtotal</div>            
                        <div className="w-16 text-center">{documentId.subtotal}</div>            
                    </div>
                    <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
                        <div className="w-[1000px]">Subtotal Presupuesto</div>            
                        <div className="w-16 text-center">{documentId.subTotalPresupuesto}</div>            
                    </div>
                    <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
                        <div className="w-[600px]">Coeficiente: {documentId.coeficiente}</div>
                        <div className="w-[390px] text-[10pt]">Total</div>
                        <div className="w-20 text-[10pt] text-center">{documentId.totalCoeficiente}</div>
                    </div>
                    <div className="mt-4 text-[9pt] border-b-2 border-slate-300">
                        <div className="flex">
                            <p>Item 1 -</p>
                            <p className="ml-4">{documentId.item1 ? documentId.item1.clave : ""}:</p>
                            <p className="ml-2">{documentId.item1 ? documentId.item1.valor : ""}</p>
                        </div>
                        <div className="flex">
                            <p>Item 2 -</p>
                            <p className="ml-4">{documentId.item2 ? documentId.item2.clave : ""}:</p>
                            <p className="ml-2">{documentId.item2 ? documentId.item2.valor : ""}</p>
                        </div>
                        <div className="flex">
                            <p>Item 3 -</p>
                            <p className="ml-4">{documentId.item3 ? documentId.item3.clave : ""}:</p>
                            <p className="ml-2">{documentId.item3 ? documentId.item3.valor : ""}</p>
                        </div>
                        <div className="flex">
                            <p>Item 4 -</p>
                            <p className="ml-4">{documentId.item4 ? documentId.item4.clave : ""}:</p>
                            <p className="ml-2">{documentId.item4 ? documentId.item4.valor : ""}</p>
                        </div>
                    </div>
                    <div className="flex mt-5 text-[12pt] border-b-2 border-slate-300">
                        <p>Total: </p>
                        <p className="ml-5">{documentId.totalDocumento}</p>
                    </div>
                    <div className="flex flex-row w-[300px]">
                    <div>
                        <button
                            className="mt-12 p-4 rounded bg-sky-500 text-white hover:text-black w-[130px]" 
                            onClick={opendPDF}
                        >
                            Ver PDF
                        </button>
                    </div>
                    <div>
                        <button
                            className="mt-12 p-4 rounded bg-red-500 text-white hover:text-black w-[130px] ml-4"
                            onClick={brutoPDF}
                        >
                            Ver PDF bruto
                        </button>
                    </div>
                    </div>
                    <div>
          {verPDF ? (
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
            >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              <div>
              <DetailPresupuestoPDF
                  key={id} 
                  id={id}
                  presupuesto={documentId}
                  bruto={pdfBruto}
              />
              </div>
            </div>
          ) : null}
        </div>
            </div>
        </div>
    )
}